// @flow
//
// We have two parts to the AVM flow, the `OnlineValuation` which is followed
// by the `PersonalValuation` flow. These share some things, such as how to
// calculate lead score, so here we go putting in a generic "shared" "util"
// file for them to live in. I (@seddy) will wax lyrical about how I fucking
// hate "util" folders, but I can't find anywhere else sensible to put this.
// So here it is.
// Iwantedaprofanityherebutreviewermademetakeitout.

import { type State } from "../components/MultiStageForm/ducks";

export const calculateAvmLeadScore = ({
  customerIntent,
  urgency,
}: State): string => {
  if (customerIntent === "ALREADY_ON_THE_MARKET") return "THREE";

  if (urgency === "NOT_SELLING") return "ONE";

  const lowIntent = ["THINKING_ABOUT_IT", "JUST_CURIOUS"];
  if (urgency === "SIX_MONTHS_PLUS" && lowIntent.includes(customerIntent)) {
    return "ONE";
  }

  return "TWO";
};
